<!-- HelpCenter -->
<template>
  <div class="container detail" ref="detail">
    <div class="box">
      <h1 class="detail-title">{{content.title}}</h1>
      <div class="detail-item" v-for="(item, index) in content.contents" :key="index">
        <div class="text" v-html="item.text" v-if="item.text"></div>
        <img class="pic" :src="item.picUrl" alt="" v-if="item.picUrl">
      </div>

      <h1 class="detail-title" v-if="relations.length">你可能关心的问题</h1>
      <div class="relation-item" v-for="item in relations" :key="item.id" @click="()=>{goHelpDetail(item.id)}">
        <div class="text">{{item.title}}</div>
        <img class="icon-arrow" src="@/assets/helpCenter/back.png" alt="">
      </div>
    </div>

    <div class="contact" ref="contact">
      <div class="contact-item">官方客服电话：4008-255-211</div>
      <div class="contact-item">口袋故事官网：https://www.koudaistory.com</div>
      <div class="contact-item">商务联系邮件：bd@tongruiai.com</div>
      <div class="contact-item">市场联系邮件：marketing@tongruiai.com</div>
    </div>
  </div>
</template>

<script>
import config from '@/config/config'
import { matches, filter } from 'lodash'
import helpData from './help_config'
import helpDataWatch from './help_config_watch'

export default {
  data() {
    return {
      content: {
        contents: [],
        relations: []
      },
      relations: []
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData (helpId) {
      let tempData = []
      let id = helpId || this.$route.query.id
      switch (this.$route.query.type) {
        case 'watch':
          tempData = helpDataWatch
          break
        default:
          tempData = helpData
      }
      let content = []
      for (let i = 0; i < tempData.list.length; i++) {
        content = filter(tempData.list[i].list, matches({ id: id }))
        if (content.length) break
      }
      if (!content.length) {
        window.location.href = `${config.siteRoot}/helpcenter?type=${this.$route.query.type}`
      }
      this.content = content[0]
      let relations = []
      for (let i = 0; i < tempData.list.length; i++) {
        for (let j = 0; j < tempData.list[i].list.length; j++) {
          for (let k = 0; k < this.content.relations.length; k++) {
            if (this.content.relations[k] == tempData.list[i].list[j].id) {
              relations.push(tempData.list[i].list[j])
            }
          }
        }
      }
      this.relations = relations
    },

    goHelpDetail (helpId) {
      this.initData(helpId)
      
      window.scrollTo(0, 0)
      this.$nextTick(() => {
        this.initHeight()
      })
    },

    initHeight () {
      this.$refs.detail.style.height = 'auto'
      console.log(this.$refs.detail.offsetHeight, window.innerHeight, this.$refs.contact.offsetHeight)
      if (this.$refs.detail.offsetHeight < window.innerHeight - this.$refs.contact.offsetHeight - 20) {
        console.log(this.$refs.detail.style)
        this.$refs.detail.style.height = window.innerHeight + 'px'
      } else {
        this.$refs.detail.style.height = 'auto'
      }
    }
  },
  mounted () {
    this.initHeight()
  }
}
</script>

<style scoped lang="less">
@import "~@/styles/fn";

.container {
  padding: .28rem .44rem;
  background: #fff;
  box-sizing: border-box;
}

.detail {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.detail-title {
  margin-bottom: .2rem;
  padding-bottom: .16rem;
  font-size: .32rem;
  color: #2c2a40;
  box-shadow: inset 0 -1px 0 0 #f4f4f8;
}

.detail-item {
  margin-bottom: .4rem;
  .text {
    color: #6c6c74;
    font-size: .28rem;
    text-align: justify;
  }
  .pic {
    display: block;
    margin-top: .2rem;
    max-width: 100%;
  }
}

.relation-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: .84rem;
  font-size: .28rem;
  color: #6c6c74;
  text-align: left;
  box-sizing: border-box;
  box-shadow: inset 0 -1px 0 0 #f4f4f8;
  .icon-arrow {
    display: block;
    width: .44rem;
    height: .44rem;
  }
}

.contact {
  margin-top: .8rem;
  &-item {
    line-height: .42rem;
    text-align: center;
    color: #a0a0a6;
    font-size: .24rem;
  }
}

</style>
